import { FaFacebookF } from "react-icons/fa6";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  window.scrollTo({ top: el.offsetTop - 64, behavior: 'smooth' });
};

const NAV_LINKS = [
  { id: 'home', label: 'Home' },
  { id: 'skills', label: 'Skills' },
  { id: 'experience', label: 'Experience' },
  { id: 'projects', label: 'Projects' },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <span className="footer-brand">JM Balatico</span>
        <nav className="footer-nav">
          {NAV_LINKS.map(({ id, label }) => (
            <a key={id} href={`#${id}`} onClick={(e) => { e.preventDefault(); scrollTo(id); }}>
              {label}
            </a>
          ))}
        </nav>
      </div>

      <div className="footer-right">
        <div className="footer-socials">
          <a
            className="footer-social-link"
            href="https://web.facebook.com/john.balatico.1/"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebookF />
          </a>
          <a
            className="footer-social-link"
            href="https://github.com/Emmm-07"
            target="_blank"
            rel="noreferrer"
          >
            <FaGithub />
          </a>
          <a
            className="footer-social-link"
            href="https://www.linkedin.com/in/john-michael-balatico-ba328530a/"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedinIn />
          </a>
        </div>
        <span className="footer-copy">© 2024 · Metro Manila, Philippines</span>
      </div>
    </footer>
  );
};

export default Footer;
